/**
 * Metric group definitions for KeyMetrics view.
 * Extracted from KeyMetrics.jsx for reusability and maintainability.
 *
 * Note: TRAJECTORY_BASE_METRICS, TRAJECTORY_TTM_METRICS, MARGIN_METRICS, and OPEX_METRICS
 * are now derived from METRICS_REGISTRY views. Use getTrajectoryMetrics() and getMarginMetrics()
 * from utils/metricHelpers.js instead.
 */

// Define explicit group ordering for trended table
export const GROUP_ORDER = [
  'Top-line Metrics',
  'Unit Economics',
  'Profitability Metrics',
  'Business Composition',
];

// Mapping from percentage field names to raw data field names
export const PERCENT_FIELD_TO_RAW_FIELD = {
  'GM % of Sales': 'Gross Margin',
  'S&M % of Sales': 'Sales & Marketing',
  'R&D % of Sales': 'Research & Development',
  'G&A % of Sales': 'General & Administrative',
  'FCF % of Sales': 'Free Cash Flow',
};

// View types for KeyMetrics
export const KEY_METRICS_VIEWS = {
  DASHBOARD: 'graph',
  MODEL: 'table',
  ACCEL: 'accel',
  MARGINS: 'margins',
};

// Default storage key for view persistence
export const KEY_METRICS_VIEW_STORAGE_KEY = 'keyMetricsView';

// SBC treatment modes
export const SBC_MODES = {
  INCLUDING: 'including',
  EXCLUDING: 'excluding',
};

// Storage key for SBC mode persistence
export const SBC_MODE_STORAGE_KEY = 'keyMetricsSbcMode';
